import { styles } from '@app/services/app-styles.service';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import _colorScheme from '@styles/primeng/_color-scheme';
import autocomplete from '@styles/primeng/autocomplete';
import badge from '@styles/primeng/badge';
import breadcrumb from '@styles/primeng/breadcrumb';
import card from '@styles/primeng/card';
import checkbox from '@styles/primeng/checkbox';
import chip from '@styles/primeng/chip';
import datatable from '@styles/primeng/datatable';
import dialog from '@styles/primeng/dialog';
import image from '@styles/primeng/image';
import listbox from '@styles/primeng/listbox';
import stepper from '@styles/primeng/stepper';
import tag from '@styles/primeng/tag';
import toast from '@styles/primeng/toast';
import togglebutton from '@styles/primeng/togglebutton';
import tooltip from '@styles/primeng/tooltip';
import treetable from '@styles/primeng/treetable';

const _primengConfig = definePreset(Aura, {
    components: {
        badge: badge,
        toast: toast,
        listbox: listbox,
        image: image,
        dialog: dialog,
        card: card,
        chip: chip,
        autocomplete: autocomplete,
        tooltip: tooltip,
        checkbox: checkbox,
        datatable: datatable,
        treetable: treetable,
        togglebutton: togglebutton,
        breadcrumb: breadcrumb,
        stepper: stepper,
        tag: tag,
    },
    semantic: {
        primary: {
            100: styles().primary100,
            150: styles().primary150,
            200: styles().primary200,
            250: styles().primary250,
            300: styles().primary300,
            350: styles().primary350,
            400: styles().primary400,
            450: styles().primary450,
            500: styles().primary500,
            550: styles().primary550,
            600: styles().primary600,
            650: styles().primary650,
            700: styles().primary700,
            750: styles().primary750,
            800: styles().primary800,
            850: styles().primary850,
            900: styles().primary900,
        },
        red: {
            100: styles().warn100,
            150: styles().warn150,
            200: styles().warn200,
            250: styles().warn250,
            300: styles().warn300,
            350: styles().warn350,
            400: styles().warn400,
            450: styles().warn450,
            500: styles().warn500,
            550: styles().warn550,
            600: styles().warn600,
            650: styles().warn650,
            700: styles().warn700,
            750: styles().warn750,
            800: styles().warn800,
            850: styles().warn850,
            900: styles().warn900,
        },
        green: {
            100: styles().green100,
            150: styles().green150,
            200: styles().green200,
            250: styles().green250,
            300: styles().green300,
            350: styles().green350,
            400: styles().green400,
            450: styles().green450,
            500: styles().green500,
            550: styles().green550,
            600: styles().green600,
            650: styles().green650,
            700: styles().green700,
            750: styles().green750,
            800: styles().green800,
            850: styles().green850,
            900: styles().green900,
        },
        sky: {
            100: styles().primary100,
            150: styles().primary150,
            200: styles().primary200,
            250: styles().primary250,
            300: styles().primary300,
            350: styles().primary350,
            400: styles().primary400,
            450: styles().primary450,
            500: styles().primary500,
            550: styles().primary550,
            600: styles().primary600,
            650: styles().primary650,
            700: styles().primary700,
            750: styles().primary750,
            800: styles().primary800,
            850: styles().primary850,
            900: styles().primary900,
        },
        colorScheme: _colorScheme,
    },
});

export default _primengConfig;
